import { makeStyles } from '@/styles/theme/tss-react';
import { darkOrLightStyle } from '@/utils/styles';

const useStyles = makeStyles<{
  increasePadding: boolean;
  isOnDark: boolean;
}>({
  name: 'SelectableCard',
})(({ spacing, brandColors, typography: { pxToRem } }, props) => ({
  selectableCard: {
    borderRadius: pxToRem(8),
    backgroundColor: darkOrLightStyle(props)(
      brandColors.black,
      brandColors.white
    ),
    border: `1px solid`,
    borderColor: darkOrLightStyle(props)(
      brandColors.tintsNeutral20,
      brandColors.tintsOffWhite40
    ),
    padding: props.increasePadding ? spacing(1) : spacing(0),
    cursor: 'pointer',
    '&:hover': {
      borderColor: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
    },
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  selected: {
    outline: `${pxToRem(2)} solid`,
    outlineColor: darkOrLightStyle(props)(
      brandColors.white,
      brandColors.primaryMain
    ),
    outlineOffset: pxToRem(-1),
  },
  disabled: {
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsMediumBlue20,
      brandColors.tintsHeroBlue90
    ),
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
    border: '1px solid transparent',
    cursor: 'default',
    '&:hover': {
      borderColor: 'transparent',
    },
  },
  srOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  },
}));

export default useStyles;
